import { AuthUser, Function } from '@/app/pages/auth/models/auth.model';
import { Menu } from '@/app/pages/menu-system/models/menu.model';

export interface AuthState {
  currentUser: AuthUser | null;
  access_token: string | null;
  permissions: Function[] | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  menus: Menu[];
}

export const initialAuthState: AuthState = {
  currentUser: null,
  access_token: null,
  permissions: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  menus: [],
};
